import { RefObject, MutableRefObject, useRef, ForwardedRef } from "react";

export function usePassedRef<T, R extends ForwardedRef<T>>(passedRef: R, initialValue?: T): Exclude<R, null>;
export function usePassedRef<T, R extends RefObject<T>>(passedRef?: R | undefined | null, initialValue?: T): R;
export function usePassedRef<T>(passedRef?: MutableRefObject<T> | undefined | null, initialValue?: T): MutableRefObject<T>;
export function usePassedRef<T>(passedRef?: RefObject<T> | MutableRefObject<T> | ForwardedRef<T> | null, initialValue?: T): RefObject<T> | MutableRefObject<T> | ForwardedRef<T> {
    const localRef = useRef<T>(initialValue ?? null);

    return passedRef ?? localRef;
}